<template>
  <UserForm action="edit" :user="user"/>
</template>

<script>
import UserForm from '@/components/User/UserForm'
import * as types from '@/store/types.js'

export default {
  components: {
    UserForm
  },
  computed: {
    user () {
      this.$store.dispatch(types.ACTIVE_USER)
      return this.$store.getters[types.ACTIVE_USER]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/Edit.vue